/* eslint-disable no-useless-escape */

// Arabic text with numbers and common punctuation
export const ARABIC_TEXT_WITH_NUMBERS_REGEX =
  /^[\p{Script_Extensions=Arabic}0-9 \r\n.,،'’()\-]+$/u;

// Arabic + English address with extended characters
export const ARABIC_ENGLISH_ADDRESS_EXTENDED_REGEX =
  /^[\p{Script_Extensions=Arabic}0-9a-zA-Z .,،'’"«»()\-#/№\\_&]+$/u;

export const ENGLISH_ADDRESS_EXTENDED_REGEX =
  /^[a-zA-Z0-9 .,'"«»()\-#/№\\_&]+$/;

// Name regex: English + Arabic letters, spaces, hyphen, apostrophes
export const ENG_ARABIC_NAME_REGEX =
  /^[A-Za-z\p{Script_Extensions=Arabic} '’-]+$/u;

// Regex for Arabic characters only
export const ARABIC_CHAR_REGEX = /\p{Script_Extensions=Arabic}/u;

// Regex for all letters: English + Arabic
export const LETTER_REGEX = /[a-zA-Z\p{Script_Extensions=Arabic}]/u;

export const ARABIC_TEXT_WITH_NUMBERS_AND_SIGNS_REGEX =
  /^[\p{Script_Extensions=Arabic}0-9 \r\n!"#$%&'()*+№,،’\-./:;<=>?@[\\\]^_`{|}~]+$/u;

export const ARABIC_ENGLISH_TEXT_WITH_NUMBERS_AND_SIGNS_REGEX =
  /^[\p{Script_Extensions=Arabic}a-zA-Z0-9 \r\n!"#$%&'()*+№,،’\-./:;<=>?@[\\\]^_`{|}~]+$/u;

export const ENGLISH_TEXT_WITH_NUMBERS_AND_SIGNS_REGEX =
  /^[a-zA-Z0-9 \r\n!"#$%&'()*+№,،’\-./:;<=>?@[\\\]^_`{|}~]+$/u;
